import React from 'react';
import Link, { withPrefix } from 'gatsby-link';

import styled, { keyframes } from 'styled-components';
import config from '../config';

// Components
import Logo from '../components/Logo';

const PageWrapper = styled.section`
  position: absolute;
  height: 90%;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const CircleWrapper = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  position: relative;
  border-radius: 50%;
  margin: 0 auto;

  > svg, > div {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const revealLogo = keyframes`
  0% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  90% {
    transform: translateY(104px) scale(0.02);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(104px) scale(0.02);
  }
`;

const SkinSVG = styled.svg`
`;

const Heading = styled.h1`
  display: ${props => props.hide ? 'none' : 'block'};
`;

const TagLine = styled.p`
  display: ${props => props.hide ? 'none' : 'block'};
`;

const Andy = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  background: url(${withPrefix('/images/andy.jpg')}) 0 0 no-repeat;;
  background-size: 100% 100%;
  animation: ${props => props.hide ? `${revealLogo} 0.6s linear forwards` : 'none' };
`;

class IntroPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      logoRevealed: false
    };
    this._handleTapped = this._handleTapped.bind(this);
  }
  _handleTapped() {

    this.setState({
      logoRevealed: !this.state.logoRevealed
    }, () => {
      const yTo = this.state.logoRevealed ? 100 : 0;
      const duration = this.state.logoRevealed ? 2 : 0.5;
      const rotation = this.state.logoRevealed ? 90 : 0;

      // TweenMax.set(this._clip1, {
      //   rotation: 0,
      //   transformOrigin: '320px center'
      // });

      TweenMax.to(this._clip1, duration, {
        rotation: -rotation,
        transformOrigin: '320px center',
        // y: yTo,
        ease: Power2.easeInOut,
        repeat: false
      });

      TweenMax.to(this._clip2, duration, {
        rotation: -rotation,
        transformOrigin: '320px center',
        ease: Power2.easeInOut,
        repeat: false,
        delay: duration * 0.4
      });

      // middle slice
      TweenMax.to(this._clip5, duration, {
        y: yTo,
        ease: Power2.easeInOut,
        repeat: false,
        delay: duration * 0.8
      });

      TweenMax.to(this._clip3, duration, {
        rotation: rotation,
        transformOrigin: '-180px center',
        ease: Power2.easeInOut,
        repeat: false,
        delay: duration * 1.2
      });

      TweenMax.to(this._clip4, duration, {
        rotation: rotation,
        transformOrigin: '-180px center',
        ease: Power2.easeInOut,
        repeat: false,
        delay: duration *  1.6
      });
    });
  }
  render() {
    const { logoRevealed } = this.state;
    return (
      <PageWrapper>
        <CircleWrapper onClick={this._handleTapped} size={320}>
          <Logo size={320} />
          <SkinSVG viewBox={`0 0 100 100`} width={320} height={320}>
            <g>
              <circle cx={50} cy={50} r={50} fill='url(#andy)' clipPath='url(#clip-1)' />
              <circle cx={50} cy={50} r={50} fill='url(#andy)' clipPath='url(#clip-2)' />
              <circle cx={50} cy={50} r={50} fill='url(#andy)' clipPath='url(#clip-3)' />
              <circle cx={50} cy={50} r={50} fill='url(#andy)' clipPath='url(#clip-4)' />
              <circle cx={50} cy={50} r={50} fill='url(#andy)' clipPath='url(#clip-5)' />
            </g>
            <g opacity={0}>
              <path d='M 0 0 h 25 c -10 10, -10 90, 0 100 h -25 z' fill='red' />
              <path d='M 25 0 h 25 c -10 10, -10 90, 0 100 h -25 c -10 -10, -10 -90, 0 -100 z' fill='blue' />
              <path d='M 50 0 h 25 c 10 10, 10 90, 0 100 h -25 c 10 -10, 10 -90, 0 -100 z' fill='green' />
              <path d='M 75 0 h 25 v 100 h -25 c 10 -10, 10 -90, 0 -100 z' fill='red' />
              <path d='M 50 0 c -12 5, -12 95, 0 100 c 12 -5, 12 -95, 0 -100 z' fill='yellow' />
            </g>
            <defs>
            <pattern id='andy' patternUnits='userSpaceOnUse' width='100%' height='100'>
              <image className='andy' xlinkHref={withPrefix('/images/andy.jpg')} x='0' y='0'
            width='100' height='100' />
            </pattern>
            <clipPath id='clip-1'>
              <path d='M 0 0 h 26 c -10 10, -10 90, 0 100 h -26 z' ref={_c => {this._clip1 = _c;}}  />
            </clipPath>
            <clipPath id='clip-2'>
              <path d='M 25 0 h 26 c -10 10, -10 90, 0 100 h -26 c -10 -10, -10 -90, 0 -100 z' ref={_c => {this._clip2 = _c;}} />
            </clipPath>
            <clipPath id='clip-3'>
              <path d='M 50 0 h 26 c 10 10, 10 90, 0 100 h -26 c 10 -10, 10 -90, 0 -100 z' ref={_c => {this._clip3 = _c;}} />
            </clipPath>
            <clipPath id='clip-4' >
              <path d='M 75 0 h 26 v 100 h -26 c 10 -10, 10 -90, 0 -100 z' ref={_c => {this._clip4 = _c;}} />
            </clipPath>
            <clipPath id='clip-5'>
              <path d='M 50 0 c -12 5, -12 95, 0 100 c 12 -5, 12 -95, 0 -100 z' ref={_c => {this._clip5 = _c;}} />
            </clipPath>
          </defs>
          </SkinSVG>
        </CircleWrapper>
        <Heading hide={logoRevealed}>@andyshora</Heading>
        <TagLine hide={logoRevealed}>JAMstack London</TagLine>
        <Heading hide={!logoRevealed}>too many kiwis</Heading>
        <TagLine hide={!logoRevealed}>{config.TAG_LINE}</TagLine>
      </PageWrapper>
    );
  }
};

export default IntroPage;



// WEBPACK FOOTER //
// ./src/pages/jamstack.js